import { render, staticRenderFns } from "./WatchNowButtonNew.vue?vue&type=template&id=1ca37515&scoped=true"
import script from "./WatchNowButtonNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./WatchNowButtonNew.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WatchNowButtonNew.vue?vue&type=style&index=0&id=1ca37515&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca37515",
  null
  
)

export default component.exports